import { MedicalSummaryMedicationDetailsSortColumn } from "@/Common/Models/Patient/PatientEnums";

export enum PrescriptionRenewalHistoryOrderType {
    Medication = MedicalSummaryMedicationDetailsSortColumn.Medication,
    Beginning = MedicalSummaryMedicationDetailsSortColumn.Beginning,
    End = MedicalSummaryMedicationDetailsSortColumn.Ended,
    Dosage = MedicalSummaryMedicationDetailsSortColumn.Dosage,
    Quantity = MedicalSummaryMedicationDetailsSortColumn.Quantity,
    Status = MedicalSummaryMedicationDetailsSortColumn.Status,
    Origin = MedicalSummaryMedicationDetailsSortColumn.Origin,
    WrittenDate = MedicalSummaryMedicationDetailsSortColumn.WrittenDate,

    // the following enum values must not exist in MedicalSummaryMedicationDetailsSortColumn
    Refills = 100,
    Duration = 101,
    Prescriber = 102
}
